
<template>
  <!--新增封禁原因-->
  <x-addEdit
    apiOrigin="PHP"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
import { addEdit } from 'ant-design-vue-admin-x';
export default {
  mixins: [fetchSelect, addEdit],
  name: 'addBanReason',
  data () {
    return {
      formList: [
        {
          label: '封禁原因',
          inputType: 'input',
          options: [],
          placeholder: '请输入封禁原因',
          props: ['title', {
            rules: [
              { required: true, message: '请输入封禁原因' },
              { min: 1, max: 20, message: '封禁原因不超过20个字' }
            ]
          }]
        },
        {
          label: '应用位置',
          inputType: 'select',
          options: [],
          placeholder: '请选择应用位置',
          props: ['type', {
            rules: [{ required: true, message: '请选择应用位置' }]
          }]
        }
      ],
      formKey: {
        title: undefined,
        type: undefined
      },
      addParam: {
        url: '/chat/category/forbidden',
        reqHandle: '', // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/chat/category/forbidden/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/chat/category/forbidden/',
        resHandle: '' // this.resHandle
      }
    };
  },
  created () {
    if (this.$route.query.id) {
      this.formList[1].disabled = true;
    }
    this.getSelect();
  },
  methods: {
    /* 获取下拉 */
    getSelect () {
      this._get({
        url: '/chat/category/forbidden_select',
        params: {}
      }).then(({data}) => {
        this.formList[1].options = data.type;
      });
    },
    resHandle (res) {
      return {};
    },
    reqHandle (param) {
      console.log('处理请求前数据: ', param);
      return param;
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>
